import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import { IUserIpDetailsForAnalytics } from "./UserIp.interfaces";

export const default_user_ip_details_for_analytics_info: IUserIpDetailsForAnalytics =
    {
        data: { country: null, city: null, state: null },
        metadata: { updatedAt: null },
    };

// api urls - start
/**
 * get api call to fetch user ip details from a free end point https://geolocation-db.com/json/
 */
export const GET_USER_IP_DETAILS_API_URL = appendURLSearchParams(
    "https://pro.ip-api.com/json",
    { key: process.env.NEXT_PUBLIC_IP_GEOLOCATION_KEY }
);

export const CLOUDFLARE_IP_GEOLOC_API_URL =
    "https://www.cloudflare.com/cdn-cgi/trace/";

export const GEOLOC_DB_API_URL = "https://geolocation-db.com/json/";

// api urls - end
